import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export function Copyright(props: any) {
    return (
        <Typography variant="body2" {...props}>
            {'Copyright © '}
            {new Date().getFullYear()}
            <Link
                color="inherit"
                href="https://www.comware.com.co/"
                sx={{ px: 1 }}
            >
                ComWare
            </Link>
            {'Bogotá - Colombia'}
        </Typography>
    );
}
